import { Injectable, Injector } from '@angular/core';
import { config } from '../../../providers/config';
import {
  Http,
  ConnectionBackend,
  Request,
  RequestOptions,
  RequestOptionsArgs,
  Response,
  Headers
} from '@angular/http';
import { Observable } from "rxjs/Rx";
//import { Observable } from 'rxjs/Observable';
//import { LoaderService } from "./loader-service";
import 'rxjs/Rx';
import { LoaderService } from './loader.service';
import { environment } from '../../../environments/environment';
import { LoginService } from './login.service';
import { NavbarComponent } from '../../components/navbar/navbar.component';
import { Router } from '@angular/router';

@Injectable()
export class HttpService extends Http {
  environment = environment;
  constructor(
    //private loaderService: LoaderService
    backend: ConnectionBackend,
    defaultOptions: RequestOptions,
    private loaderService: LoaderService,
  private router: Router){
      super(backend, defaultOptions);
      // const auth = this.inj.get(NavbarComponent);
    }

    /**
    * Performs any type of http request.
    * @param url
    * @param options
    * @returns {Observable<Response>}
    */

    request(url: string | Request, options?: RequestOptionsArgs): Observable<Response> {
      return super.request(url, options);
    }

    /**
    * Performs a request with `get` http method.
    * @param url
    * @param options
    * @returns {Observable<>}
    */

    get(url: string, options?: RequestOptionsArgs): Observable<any> {
      this.requestInterceptor();
      return super.get(this.getFullUrl(url), this.requestOptions(options))
      .catch(this.onCatch.bind(this))
      .do((res: Response) => {
        this.onSubscribeSuccess(res);
      }, (error: any) => {
        this.onSubscribeError(error);
      })
      .finally(() => {
        this.onFinally();
      });
    }

    getLocal(url: string, options?: RequestOptionsArgs): Observable<any> {
      return super.get(url, options);
    }

    /**
    * Performs a request with `post` http method.
    * @param url
    * @param body
    * @param options
    * @returns {Observable<>}
    */

    post(url: string, body: any, options?: RequestOptionsArgs): Observable<any> {
      // console.log('http-postReqest', {url, body}, this.environment, environment);
      if(this.environment.ROLE != 'lsa'){
        this.requestInterceptor();
      } else {
        if(url.indexOf('saveHotelChainAdmin') == -1) {
          this.requestInterceptor();
        }
      }

      return super.post(this.getFullUrl(url), body, this.requestOptions(options))
      .catch(this.onCatch.bind(this))
      .do((res: Response) => {
        this.onSubscribeSuccess(res);
      }, (error: any) => {
        this.onSubscribeError(error);
      })
      .finally(() => {
        this.onFinally();
      });
    }

    /**
    * Performs a request with `put` http method.
    * @param url
    * @param body
    * @param options
    * @returns {Observable<>}
    */

    put(url: string, body: string, options?: RequestOptionsArgs): Observable<any> {
      this.requestInterceptor();
      return super.put(this.getFullUrl(url), body, this.requestOptions(options))
      .catch(this.onCatch.bind(this))
      .do((res: Response) => {
        this.onSubscribeSuccess(res);
      }, (error: any) => {
        this.onSubscribeError(error);
      })
      .finally(() => {
        this.onFinally();
      });
    }

    /**
    * Performs a request with `delete` http method.
    * @param url
    * @param options
    * @returns {Observable<>}
    */

    delete(url: string, options?: RequestOptionsArgs): Observable<any> {
      this.requestInterceptor();
      return super.delete(this.getFullUrl(url), options)
      .catch(this.onCatch.bind(this))
      .do((res: Response) => {
        this.onSubscribeSuccess(res);
      }, (error: any) => {
        this.onSubscribeError(error);
      })
      .finally(() => {
        this.onFinally();
      });
    }


    /**
    * Request options.
    * @param options
    * @returns {RequestOptionsArgs}
    */

    private requestOptions(options?: RequestOptionsArgs): RequestOptionsArgs {
      if (options == null) {
        options = new RequestOptions();
      }
      if (options.headers == null) {
        options.headers = new Headers();
      }

      let Mytoken = localStorage.getItem('loggedInUser') ? JSON.parse(localStorage.getItem('loggedInUser')).token : null;

      if(Mytoken){
        options.headers.append('Content-Type', 'application/json');
        options.headers.append('X-Auth-Token', Mytoken);
      }else {
        options.headers.append('Content-Type', 'application/x-www-form-urlencoded');
      }

      return options;
    }

    /**
    * Build API url.
    * @param url
    * @returns {string}
    */

    private getFullUrl(url: string): string {
      return environment.BASE_API + environment.ROLE + url;
    }

    /**
    * Request interceptor.
    */

    private requestInterceptor(): void {
      //this.loaderService.showPreloader();
      this.loaderService.show();
    }

    /**
    * Response interceptor.
    */

    private responseInterceptor(): void {
      //this.loaderService.hidePreloader();
      this.loaderService.hide();
    }


    logout(url) {
      // Default options are marked with *
      let Mytoken = localStorage.getItem('loggedInUser') ? JSON.parse(localStorage.getItem('loggedInUser')).token : null;
      return fetch(url, {
        cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
        credentials: 'same-origin', // include, *omit
        headers: {
          'content-type': 'application/json',
          'X-Auth-Token': Mytoken
        },
        method: 'GET', // *GET, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *same-origin
        redirect: 'follow', // *manual, error
        referrer: 'no-referrer', // *client
      })
      .then(response => response.json()) // parses response to JSON
    }

    /**
    * Error handler.
    * @param error
    * @param caught
    * @returns {ErrorObservable}
    */

    private onCatch(error: any, caught: Observable<any>): Observable<any> {
      if(error.status == 401) {
        this.logout(this.getFullUrl('/signout')).then(res => {
          localStorage.clear();
          this.router.navigate(['/login']);
        });
      }
      return Observable.throw(error);
    }

    /**
    * onSubscribeSuccess
    * @param res
    */

    private onSubscribeSuccess(res: Response): void {
      let contentType = res.headers.get('content-type');
      if(contentType && contentType.indexOf('text/html') > -1) {
        this.logout(this.getFullUrl('/signout')).then(res => {
          localStorage.clear();
          this.router.navigate(['/login']);
        });
      }
    }

    /**
    * onSubscribeError
    * @param error
    */

    private onSubscribeError(error: any): void {
      //Rules here
      console.log(error,'error')
    }

    /**
    * onFinally
    */

    private onFinally(): void {
      this.responseInterceptor();
    }
  }



// WEBPACK FOOTER //
// ./src/app/shared/_services/http.service.ts